/**
 * Configure your Gatsby site with this file.
 *
 * See: https://www.gatsbyjs.com/docs/reference/config-files/gatsby-browser/
 */

 import "./src/assets/css/fontawesome-all.min.css"  

import "./src/assets/sass/main.scss"
import "./src/assets/sass/custom.scss"